import pxToRem from '../utils/pxToRem';
const EXCLUSIVE_STEP = 0.05;

const createBreakpoints = () => {
  const breakpointsObj = {
    xxs: 'xxs',
    xs: 'xs',
    sm: 'sm',
    mds: 'mds',
    md: 'md',
    lg: 'lg',
    xl: 'xl',
  };
  const names = ['xxs', 'xs', 'sm', 'mds', 'md', 'lg', 'xl'];
  const values = {
    xxs: 0,
    xs: 320,
    sm: 480,
    mds: 760,
    md: 960,
    lg: 1280,
    xl: 1600,
  };

  const up = (breakpoint) => {
    const value = values[breakpoint];
    if (value === undefined) {
      throw new Error(`${breakpoint} is invalid breakpoint name!`);
    }
    return `@media (min-width:${pxToRem(value)})`;
  };

  const down = (breakpoint) => {
    const value = values[breakpoint];
    if (value === undefined) {
      throw new Error(`${breakpoint} is invalid breakpoint name!`);
    }
    return `@media (max-width:${pxToRem(value - EXCLUSIVE_STEP)})`;
  };

  const between = (start, end) => {
    const startValue = values[start];
    if (startValue === undefined) {
      throw new Error(`${startValue} is invalid breakpoint name!`);
    }
    const endValue = values[end];
    if (endValue === undefined) {
      throw new Error(`${endValue} is invalid breakpoint name!`);
    }

    return `@media (min-width:${pxToRem(startValue)}) and (max-width:${pxToRem(
      endValue - EXCLUSIVE_STEP
    )})`;
  };

  const only = (breakpoint) => {
    if (names.indexOf(breakpoint) + 1 < names.length) {
      return between(breakpoint, names[names.indexOf(breakpoint) + 1]);
    }
    return up(breakpoint);
  };

  return {
    ...breakpointsObj,
    names,
    values,
    up,
    down,
    between,
    only,
  };
};

export default createBreakpoints;
